
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Module": () => {
return Promise.all(/*  | __federation_expose_Module */ [__webpack_require__.e("620"), __webpack_require__.e("498"), __webpack_require__.e("478"), __webpack_require__.e("145")]).then(() => (() => (__webpack_require__(9997))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };